export type WidgetDockSide = 'left' | 'right'

export const WIDGET_DOCK_STORAGE_KEY = 'connect-widget-dock-side'

export function readWidgetDockSide(): WidgetDockSide {
  try {
    const raw = localStorage.getItem(WIDGET_DOCK_STORAGE_KEY)
    if (raw === 'left' || raw === 'right') return raw
  } catch {
    // ignore storage errors
  }
  return 'right'
}

export function writeWidgetDockSide(side: WidgetDockSide): void {
  try {
    localStorage.setItem(WIDGET_DOCK_STORAGE_KEY, side)
  } catch {
    // ignore storage errors
  }
}
